namespace Matrix.Workflow {

    @Serenity.Decorators.registerFormatter("Matrix.Workflow.EntityTypeFormatter")
    export class EntityTypeFormatter implements Slick.Formatter {
        format(ctx: Slick.FormatterContext) {
            if (!ctx.value)
                return "";

            var table = Q.getLookup("Workflow.EntityType").itemById[ctx.value] as any;
            if (!table)
                return "?";

            return table.DisplayName;
        }
    }
}